<div class="header-container">
  <div class="logo">
    <div class="logo-name" (click)="onClickLogo()">
      <!-- <div class="logo-title">
        <div class="first-letter">
          <img src="../../assets/images/header-logo.png" alt="" />
        </div>
        <div class="next-letter">
          <div class="second-letter">
            the <span class="orange-color">lab</span>oratory
          </div>
          <div class="third-letter">matters</div>
          <div class="fourth-letter">
            <span> excellence </span> <span> through </span>
            <span class="orange-color"> expertise </span>
          </div>
        </div>
      </div> -->
      <img src="../../assets/images/header.jpg" alt="">
    </div>
    <div *ngIf="!authService.loggedIn" class="login-signup-btn" (click)="onClickLogin()">
      <button>Login / Sign up</button>
    </div>
    <div *ngIf="authService.loggedIn" class="login-signup-btn">
      <!-- <div class="cart-btn">
        <div class="cart-length">
          {{(userDetails$ | async).cart.length}}
        </div>
        <button (click)="onClickCart()">
          <i class="fa-solid fa-cart-plus"></i>
        </button>
      </div> -->
      <button (click)="onClickLogout()">Logout</button>
    </div>
    <div (click)="onClickMenuBar()" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" class="menu-btn"
      aria-controls="offcanvasNavbar">
      <i class="fa-solid fa-bars"></i>
    </div>
  </div>
  <div class="nav-bar">
    <nav>
      <ul>
        <i (click)="onClickMenuBar()" class="fas fa-times close-btn"></i>
        <li *ngIf="authService.isAdmin && authService.loggedIn">
          <a [routerLink]="'admin/manageSubscriptions'" id="top" [ngStyle]="{
              'font-weight': activeSection == 'manageSubscriptions' ? 'bold' : 'normal'
            }" (click)="onClickMenu('manageSubscriptions')">Manage Subscriptions</a>
        </li>
        <li *ngIf="authService.isAdmin && authService.loggedIn">
          <a [routerLink]="'admin/manageUsers'" id="top" [ngStyle]="{
              'font-weight': activeSection == 'manageUsers' ? 'bold' : 'normal'
            }" (click)="onClickMenu('manageUsers')">Manage Users</a>
        </li>
        <li *ngIf="authService.loggedIn">
          <a id="top" [ngStyle]="{
              'font-weight': activeSection == 'dashboard' ? 'bold' : 'normal'
            }" (click)="onClickMenu('dashboard')">Dashboard</a>
        </li>
        <li>
          <a [routerLink]="'sample-courses'" [ngStyle]="{
              'font-weight': activeSection == 'sample-courses' ? 'bold' : 'normal'
            }" (click)="onClickMenu('sample-courses')">Sample Courses</a>
        </li>
        <li>
          <a [routerLink]="'about'" id="top" [ngStyle]="{
              'font-weight': activeSection == 'about' ? 'bold' : 'normal'
            }" (click)="onClickMenu('about')">About us</a>
        </li>
        <li>
          <a [routerLink]="'pricing'" id="top" [ngStyle]="{
              'font-weight': activeSection == 'pricing' ? 'bold' : 'normal'
            }" (click)="onClickMenu('pricing')">Pricing</a>
        </li>
        <li>
          <a [routerLink]="'contact'" [ngStyle]="{
              'font-weight': activeSection == 'contact' ? 'bold' : 'normal'
            }" (click)="onClickMenu('contact')">Contact us</a>
        </li>
        <li *ngIf="authService.isAdmin">
          <a [routerLink]="'admin/courses'" [ngStyle]="{
              'font-weight':
                activeSection == 'course-wizard' ? 'bold' : 'normal'
            }" (click)="onClickMenu('course-wizard')">Course Wizard</a>
        </li>
        <li *ngIf="authService.isAdmin">
          <a [routerLink]="'admin/announcement-design'" [ngStyle]="{
              'font-weight':
                activeSection == 'announcement-design' ? 'bold' : 'normal'
            }" (click)="onClickMenu('announcement-design')">Announcement</a>
        </li>
        <li>
          <a [routerLink]="'courses'" [ngStyle]="{
              'font-weight': activeSection == 'courses' ? 'bold' : 'normal'
            }" (click)="onClickMenu('courses')">Courses</a>
        </li>
        <li>
          <a [routerLink]="'blogs'" [ngStyle]="{
              'font-weight': activeSection == 'blogs' ? 'bold' : 'normal'
            }" (click)="onClickMenu('blogs')">Blog</a>
        </li>
        <!-- <li>
          <a
            href="#"
            [ngStyle]="{
              'font-weight': activeSection == 'faq' ? 'bold' : 'normal'
            }"
            (click)="onClickMenu('faq')"
            >FAQ</a
          >
        </li> -->
      </ul>
    </nav>
  </div>

  <div class="offcanvas offcanvas-end shadow" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
    <div class="offcanvas-body">
      <i (click)="onClickMenuBar()" class="fas fa-times close-btn" data-bs-dismiss="offcanvas" aria-label="Close"></i>
      <div *ngIf="!authService.loggedIn" class="login-signup-btn" data-bs-dismiss="offcanvas" aria-label="Close"
        (click)="onClickLogin()">
        <button>Login / Sign up</button>
      </div>
      <div *ngIf="authService.loggedIn" class="login-signup-btn" data-bs-dismiss="offcanvas" aria-label="Close"
        (click)="onClickLogout()">
        <button>Logout</button>
      </div>
      <ul class="navbar-nav">
        <li *ngIf="authService.isAdmin && authService.loggedIn">
          <a [routerLink]="'admin/manageUsers'" data-bs-dismiss="offcanvas" aria-label="Close" [ngStyle]="{
              color: activeSection == 'manage' ? '#000' : '#fff'
            }" (click)="onClickMenu('manage')">Manage Users</a>
        </li>
        <li *ngIf="!authService.isAdmin && authService.loggedIn">
          <a [routerLink]="'student/1234/dashboard'" data-bs-dismiss="offcanvas" aria-label="Close" [ngStyle]="{
              color: activeSection == 'dashboard' ? '#000' : '#fff'
            }" (click)="onClickMenu('dashboard')">Dashboard</a>
        </li>
        <li>
          <a [routerLink]="'about'" data-bs-dismiss="offcanvas" aria-label="Close"
            [ngStyle]="{ color: activeSection == 'about' ? '#000' : '#fff' }" (click)="onClickMenu('about')">About
            us</a>
        </li>
        <li>
          <a [routerLink]="'contact'" data-bs-dismiss="offcanvas" aria-label="Close"
            [ngStyle]="{ color: activeSection == 'contact' ? '#000' : '#fff' }" (click)="onClickMenu('contact')">Contact
            us</a>
        </li>
        <li *ngIf="authService.isAdmin">
          <a [routerLink]="'admin/courses'" data-bs-dismiss="offcanvas" aria-label="Close" [ngStyle]="{
              color: activeSection == 'course-wizard' ? '#000' : '#fff'
            }" (click)="onClickMenu('course-wizard')">Course Wizard</a>
        </li>
        <li>
          <a [routerLink]="'courses'" data-bs-dismiss="offcanvas" aria-label="Close"
            [ngStyle]="{ color: activeSection == 'courses' ? '#000' : '#fff' }"
            (click)="onClickMenu('courses')">Courses</a>
        </li>
        <li>
          <a [routerLink]="'blogs'" data-bs-dismiss="offcanvas" aria-label="Close"
            [ngStyle]="{ color: activeSection == 'blog' ? '#000' : '#fff' }" (click)="onClickMenu('blog')">Blog</a>
        </li>
        <!-- <li>
          <a
            href="#"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            [ngStyle]="{ color: activeSection == 'faq' ? '#000' : '#fff' }"
            (click)="onClickMenu('faq')"
            >FAQ</a
          >
        </li> -->
      </ul>
    </div>
  </div>
</div>